import serviceRequest from "utils/request";

const baseUrl = "/api/data";

export const getDataRequests = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-data-requests`,
		method: "get",
		params,
	});
};

export const getDataRequestsRes = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-data-requests-res`,
		method: "get",
		params,
	});
};

export const getDataReqDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/detail`,
		method: "get",
		params,
	});
};

export const dataReqSubmit = (param) => {
	return serviceRequest({
		url: `${baseUrl}/submit`,
		method: "post",
		data: param,
	});
};

export const dataReqEdit = (param) => {
	return serviceRequest({
		url: `${baseUrl}/update`,
		method: "post",
		data: param,
	});
};
